<template>
  <div class="msoCoupon responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'msoCoupons', label: 'Mso Coupon' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";
 
export default {
  name: "msoCoupons",
  data() {
    return {
      listPageHeader,
      entity: Entities.MSOCOUPON,
    };
  },
  mounted: function () {
    this.setPageTitle("MSO Coupon");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "msoCouponModule/sort",
      pagination: "msoCouponModule/pagination",
      initialFilter: "msoCouponModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "msoCouponModule/updateSort",
      updatePagination: "msoCouponModule/updatePagination",
      updateInitialFilter: "msoCouponModule/updateInitialFilter"
    }),
  }
};
</script>
